module.exports = __webpack_public_path__ + "img/tariff-switch.e4b63b30.png";